import Model from 'src/storage/list';
import constants from 'src/constants';
import moment from 'moment';
const defaultCurrency = constants.general.defaultCurrency;

class SettingEarningDetailModel extends Model {
  id = 'SettingEarningDetailModel';
  persistent = false;
  refreshOnInit = false;
  refreshOnSubscribe = true;
  sortBy = null;
  defaultState = () => ({
    type: 'day',
    current: 'recent'
  });
  apiConfig = {
    refresh: {
      url: 'earning/list',
      validation: {
        skip: 'skip',
        limit: 'limit',
        currency: 'currency'
      },
      cancellable: true,
      event: 'earning_list'
    },
    list: {
      url: 'earning/list',
      validation: {
        skip: 'skip',
        limit: 'limit',
        currency: 'currency'
      },
      cancellable: true,
      event: 'earning_list'
    }
  };

  _events = {
    change_currency: 'handleChangeCurrency',
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  getCurrency = () => {
    return this.input('currency') || this.getUser()?.currency || defaultCurrency;
  };

  listParams(loadMore) {
    let req = {
      skip: 0,
      limit: this.listLimit,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      currency: this.getCurrency()
    };
    if (this.state.startDate) {
      req.startDate = moment(this.state.startDate).format('YYYYMMDD');
    }
    if (this.state.endDate) {
      req.endDate = moment(this.state.endDate).format('YYYYMMDD');
    }
    if (loadMore) {
      let skip = this.items().length;
      if (skip < this.listLimit) return null;
      req.skip = skip;
    }
    return req;
  }
  handleChangeCurrency = () => {
    this.refresh();
  };
}

const model = new SettingEarningDetailModel();
export default model;
